import { useContext } from 'react';
import { ViewAccrualContext } from 'src/sections/accrual-report/ViewAccrualContext';


const useViewAccrual = () => {
  const context = useContext(ViewAccrualContext);
  if (!context)
    throw new Error('View Accrual context must be used inside ViewDepartmentContextProvider');
  return context;
};

export default useViewAccrual;
